// Libs
import classNames from 'classnames/bind';
import { Box, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { TLabelValueScheduleType } from '~/utils/type/common';
// Styles, images, icons
import styles from './LabelValueSchedule.module.scss';

type Props = {
  typeStyle?: TLabelValueScheduleType;
  label?: string;
  value?: string;
};

const cx = classNames.bind(styles);

const LabelValueSchedule = (props: Props) => {
  //#region Destructuring Props
  const { label, value, typeStyle = 'small' } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='labelValueScheduleComponent' className={cx('container')}>
      {label && <Typography className={cx('label', typeStyle)}>{label}</Typography>}

      {value && <Typography className={cx('value', typeStyle)}>{value}</Typography>}
    </Box>
  );
};

export default LabelValueSchedule;
